import React from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { MdCheckCircleOutline, MdOutlineCancel } from 'react-icons/md';
import { v4 as uuid } from 'uuid';
import styled from '@emotion/styled';

const StyledIconWrapper = styled.span`
    margin-left: 8px;
    vertical-align: middle;
`;

const StyledIcon = styled.span`
    cursor: pointer;
    font-size: 16px;

    &:hover {
        opacity: 0.8;
    }
`;

/**
 * @returns {function}
 */
function SentCell({ row, value }) {
    const message = row.original;
    const tooltipId = uuid();
    const failed = Number(message.failed) === 1;
    const sentOnDate = value;
    const tooltip = <Tooltip id={tooltipId}>{failed ? message.failureMessage : 'Sent successfully'}</Tooltip>;

    return (
        <div style={{ whiteSpace: 'nowrap' }}>
            <span>{sentOnDate}</span>
            <StyledIconWrapper>
                <OverlayTrigger trigger={['hover', 'focus', 'click']} placement="top" overlay={tooltip}>
                    <StyledIcon>
                        {failed ? (
                            <MdOutlineCancel style={{ color: 'var(--brandDanger)' }} aria-label="Message failed" />
                        ) : (
                            <MdCheckCircleOutline
                                style={{ color: 'var(--brandSuccess)' }}
                                aria-label="Message sent successfully"
                            />
                        )}
                    </StyledIcon>
                </OverlayTrigger>
            </StyledIconWrapper>
        </div>
    );
}

SentCell.propTypes = {
    row: PropTypes.shape({
        original: PropTypes.shape({
            failed: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
            failureReason: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
            failureMessage: PropTypes.string,
        }),
    }).isRequired,
    value: PropTypes.string.isRequired,
};

export default SentCell;
